<template>
    <!-- <div class="page list_page gray_bg"> -->
    <div>
        <div class="detail_sell">
            <div class="page_top">
                <div class="title" @click="handleBack()"><i class="icon"></i>物件詳情</div>
                <div class="carousel_list" v-if="((sellDetail || {}).images || {}).length && !detailLoading">
                    <el-carousel :interval="5000" arrow="always">
                        <el-carousel-item v-for="({url},idx) in sellDetail.images" :key="idx">
                            <p class="carousel_img" :style="`background-image: url(${url});`"></p>
                        </el-carousel-item>
                    </el-carousel>
                </div>
            </div>
            <template v-if="detailLoading">
                <div class="loading">
                    <i class="el-icon-loading"></i>
                </div>
            </template>
            <template v-else>
                <div class="page_padding" v-if="sellDetail">
                    <ul class="list">
                        <li class="item">
                            <div class="flex space_between">
                                <p class="tit">[{{(sellDetail || {}).saleType}}]</p>
                                <p class="time">{{(sellDetail || {}).updatedAt | moment("YYYY/MM/DD")}}</p>
                            </div>
                            <p class="tit">{{(sellDetail || {}).title}}</p>
                            <p class="info">
                                <span class="area">{{(sellDetail || {}).area}}</span>
                                <span class="pay">{{(sellDetail || {}).amount ? formatNumber((sellDetail || {}).amount) : '價格面議'}}</span>
                            </p>
                        </li>
                    </ul>
                    <div class="detail">
                        <p class="tit">內容</p>
                        <p class="content">{{(sellDetail || {}).content}}</p>
                        <p class="content" v-if="(sellDetail || {}).contactName">聯絡人:{{(sellDetail ||
                            {}).contactName}}</p>
                        <p class="content" v-if="(sellDetail || {}).contactMemo">聯絡資訊:{{(sellDetail ||
                            {}).contactMemo}}</p>
                    </div>
                    <div class="photo_list" v-if="(sellDetail || {}).images">
                        <ul class="photo_flex" @click="handleOpenPhoto()">
                            <template v-if="(sellDetail || {}).images.length > 3">
                                <li class="item" v-for="idx in 3" :key="idx">
                                    <p class="photo_img"
                                       :style="`background-image: url(${sellDetail.images[idx].url})`"></p>
                                </li>
                            </template>
                            <template v-else>
                                <li class="item" v-for="({url},idx) in sellDetail.images" :key="idx">
                                    <p class="photo_img" :style="`background-image: url(${url})`"></p>
                                </li>
                            </template>
                        </ul>
                        <div class="more" v-if="sellDetail.images.length > 3" @click="handleOpenPhoto()">
                            顯示所有照片(共{{sellDetail.images.length}}張)
                        </div>
                    </div>
                    <InFeedAdsense
                        data-ad-layout-key="-fb+5w+4e-db+86"
                        data-ad-client="ca-pub-9879330354493543"
                        data-ad-slot="5365863390">
                    </InFeedAdsense>
                </div>
                <div class="footer_btn" v-if="(sellDetail || {}).mySelf">
                    <el-button class="item plan" plain :disabled="loading" @click="handleEdit()">編輯</el-button>
                    <el-button class="item" type="success" :disabled="loading" @click="handleDelete()"><i
                        class="el-icon-loading" v-if="loading"></i>刪除
                    </el-button>
                </div>
            </template>
        </div>
        <div class="photo_detail" v-if="photoVisible">
            <div class="photo_control">
                <i class="el-icon-arrow-left icon" @click="handleClosePhoto()"></i>
                <span>{{this.phtotActive + 1}}/{{sellDetail.images.length}}</span>
            </div>
            <v-touch v-on:swipeleft="swiperleft" v-on:swiperight="swiperright" class="photo_list"
                     :style="getPhotoIndex">
                <div class="item" v-for="({url},idx) in sellDetail.images" :key="idx"
                     :style="{ 'background-image': `url(${url})`}"></div>
                <!-- <div class="item" style="background-image: url(/img/sell.jpg);"></div>
                <div class="item" style="background-image: url(/img/sell.jpg);"></div> -->
            </v-touch>
        </div>
    </div>
</template>
<script>
    import BACK from '@/components/back.vue'
    import FN from '@/components/fn'
    import {mapActions, mapGetters} from 'vuex'

    export default {
        name: 'detail',
        components: {
            BACK
        },
        mixins: [FN],
        data() {
            return {
                qkSearch: false,
                phtotActive: 0,
                photoVisible: false
            }
        },
        mounted() {
            //取得詳情資料
            this.getDetail()
        },
        computed: {
            ...mapGetters([
                'sellType',
                'searchArea',
                'sellDetail'
            ]),
            interviewTypeName() {
                const type = (this.sellType || []).filter(({id}) => +id === +(this.sellDetail || {}).saleTypeId)
                return (type[0] || {}).name
            },
            getPhotoIndex() {
                const drawWidth = -100 * this.phtotActive
                return `transform: translateX(${drawWidth}vw)`
            }
        },
        methods: {
            ...mapActions([
                'FETCH'
            ]),
            getDetail() {
                this.detailLoading = true
                const id = this.$route.params.id
                this.FETCH({
                    key: 'SELL_DETAIL',
                    id: id
                }).then((res) => {
                    //需要accToken的驗證
                    if (+(res || {}).code === -3) {
                        this.checkNewToken(this.getDetail)
                    }
                    if (!+(res || {}).code) {
                        this.detailLoading = false
                    }
                })
            },
            handleEdit() {
                const id = this.$route.params.id
                this.$router.push({name: 'SellEdit', params: {id: id}})
            },
            handleDelete() {
                this.loading = true
                const id = this.$route.params.id
                this.FETCH({
                    key: 'SELL_DELETE',
                    id: id
                }).then((res) => {
                    //需要accToken的驗證
                    if (+(res || {}).code === -3) {
                        this.checkNewToken(this.handleDelete)
                    } else {
                        this.handleResponse(res)
                    }
                })
            },
            //刪除回應
            handleResponse(res) {
                if (!+res.code) {
                    this.$confirm('刪除成功', {
                        showCancelButton: false,
                        type: 'success'
                    })
                        .then(() => {
                            // const { href } = this.$router.resolve({name: 'JobList', params:{ tag: 'my'}})
                            // window.open(href, '_self')
                            this.$router.replace({name: 'Sell', params: {tag: 'my'}})
                            this.$parent.handleSearch()
                        })
                } else {
                    this.$confirm(res.message, {
                        showCancelButton: false,
                        type: 'error'
                    })
                }
                this.loading = false
            },
            handleBack() {
                this.$router.replace({name: 'Sell'})
            },
            handleClosePhoto() {
                this.photoVisible = false
            },
            handleOpenPhoto() {
                this.photoVisible = true
            },
            swiperleft: function () {
                if (this.phtotActive < this.sellDetail.images.length - 1) {
                    this.phtotActive = this.phtotActive + 1
                }
            },
            swiperright: function () {
                if (this.phtotActive) {
                    this.phtotActive = this.phtotActive - 1
                }
            },
            formatNumber(num) {
                if (num > 9999) {
                    num = num / 10000 + ' 萬'
                }
                return `NT $ ${num}`
            }
        }
    }
</script>
